var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        touchmove: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          $event.preventDefault()
        },
      },
    },
    [
      _c("div", { staticClass: "swiper-container" }, [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.imgUrls, function (item, i) {
            return _c(
              "div",
              {
                key: i,
                staticClass: "swiper-slide",
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    return _vm.handleClose.apply(null, arguments)
                  },
                },
              },
              [
                _c("img", {
                  class: { hiddenImg: _vm.isShowPreview },
                  attrs: { src: item },
                  on: {
                    click: function ($event) {
                      return _vm.showScaleImg($event, item)
                    },
                  },
                }),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.isShowPreview
        ? _c(
            "div",
            {
              ref: "scalewrap",
              staticClass: "scalewrap",
              attrs: { id: "scalewrap" },
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.handleClose.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                class: {
                  scaleimage: true,
                  scale1: _vm.scaleRate == 1,
                  scale2: _vm.scaleRate == 2,
                  scale3: _vm.scaleRate == 3,
                },
                attrs: { id: "scaleImg", src: _vm.scaleImgUrl },
                on: {
                  click: function ($event) {
                    return _vm.showScaleImg($event)
                  },
                },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }